<mat-card class="task-card" *ngIf="task" [ngClass]="{'active': !task.isComplete, 'overdue': task.isOverDue}">
  <mat-card-title class="title" (click)="openTaskDialog()">
    <h3 class="no-margin font-size-normal truncate">{{ getTypeString(task?.taskTypeLabel) | translate}}</h3>
      <span class="example-spacer"></span>
      <span class="icons hiddenToolTip">
          <mat-icon>open_in_new</mat-icon>
          <span class="download-tool-tip" [innerHTML]="'$common_details' | translate"></span>
      </span>
  </mat-card-title>
  <mat-card-content>
    <div class="row section">
      <div *ngIf="task.subject" class="col-xs-6">
        <div class="font-size-small"><span [innerHTML]="'$common_employee' | translate"></span>:</div>
        <div class="truncate">
          <cz-user-name-link [user]="task?.subject"></cz-user-name-link>
        </div>
      </div>
      <div *ngIf="!task.isComplete" class="col-xs-6">
        <div *ngIf="task.isOverDue" class="font-size-small"><span [innerHTML]="'$common_overdue' | translate"></span>:</div>
        <div *ngIf="!task.isOverDue" class="font-size-small"><span [innerHTML]="'$common_due_date' | translate"></span>:</div>
        <div class="due-date">{{ task?.dueDate | date:'MM-dd-yyyy' }}</div>
      </div>
      <div *ngIf="task.isComplete" class="col-xs-6">
        <div class="font-size-small"><span [innerHTML]="'$common_completed_date' | translate"></span>:</div>
        <div class="due-date">{{ task?.completedDate | date:'MM-dd-yyyy' }}</div>
      </div>
    </div>
    <div *ngIf="task.summary" class="row section">
      <div class="col-xs-12">
        <div class="font-size-small"><span [innerHTML]="'$common_task_summary' | translate"></span>:</div>
        <div class="truncate">{{task?.summary}}</div>
      </div>
    </div>
    <div class="row section">
      <div class="col-xs-6" *ngIf="!task.isComplete">
        <div class="font-size-small"><span [innerHTML]="'$common_assigned_to' | translate"></span>:</div>
        <div *ngIf="task?.assignedTo" class="truncate">
          <cz-user-name-link [user]="task?.assignedTo"></cz-user-name-link>
        </div>
        <div *ngIf="!task.assignedTo" class="link" [innerHTML]="'$common_n_a' | translate"></div>
      </div>

      <div class="col-xs-6" *ngIf="task.isComplete">
        <div class="font-size-small"><span [innerHTML]="'$lng_cm_lab102' | translate"></span>:</div>
        <div *ngIf="task?.completedBy" class="truncate">
          <cz-user-name-link [user]="task?.completedBy"></cz-user-name-link>
        </div>
        <div *ngIf="!task.completedBy" class="link" [innerHTML]="'$common_n_a' | translate"></div>
      </div>

      <div class="col-xs-6">
        <div class="font-size-small"><span  [innerHTML]="'$common_created_by' | translate"></span>:</div>
        <div class="truncate">
          <cz-user-name-link [user]="task?.createdBy"></cz-user-name-link>
        </div>
      </div>
    </div>
    <div *ngIf="task.notes" class="row section">
        <div class="col-xs-12">
          <div class="font-size-small"><span [innerHTML]="'$common_details' | translate"></span>:</div>
          <!-- reference UC-195 for the background on the .esspId > 0 prototype use case -->
          <div class="truncate">{{ (task.esppId > 0) ? 'None.' : task.notes }}</div>
        </div>
    </div>
    <div *ngIf="task.comments && task.comments.length > 0" class="row section">
      <div class="col-xs-12 center-xs">
        <span (click)="openTaskDialog(true)" class="link">{{ task.comments.length }} <span [innerHTML]="'$common_comments' | translate"></span></span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
